// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3tQpw","header":"Loader_header__2hYd0","headerTitle":"Loader_headerTitle__YPg5n","headerSubtitle":"Loader_headerSubtitle__1cPRp"};